<template>
  <div v-if="allLayersLoaded && $theMapObject.layers">
    <v-list expand>
      <div v-show="graphics.length == 0" class="mt-4">
        <span class="caption pa-4">Tegnelaget er tomt</span>
        <v-divider class="mt-4" />
      </div>
      <div
        v-show="graphics.length > 0"
        v-for="(graphic, index) in graphics"
        :key="index"
        :style="{ paddingLeft: padding + 'px' }"
      >
        <v-divider :key="`divider-${index}`"></v-divider>

        <layer-list-item-toc-graphicslayer-graphic
          :graphic="graphic"
          :id="layer"
          :key="index + 'graphic'"
        ></layer-list-item-toc-graphicslayer-graphic>
      </div>
    </v-list>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import LayerListItemTocGraphicslayerGraphic from "@/pages/MapPage/Tools/Layers/LayerListItemTocGraphicslayerGraphic";

export default {
  name: "LayerListItemTocGraphicslayer",
  data: function() {
    return {
      allLayersLoaded: false,
      layers: [],
      sublayers: [],
      graphics: []
    };
  },
  components: {
    LayerListItemTocGraphicslayerGraphic
  },
  props: {
    layer: String,
    padding: Number
  },
  methods: {
    updateLayer(layerId) {
      if (this.layer === layerId) {
        this.allLayersLoaded = false;
        this.loadLayer();
      }
    },
    loadLayer() {
      loadModules(["esri/Map"]).then(
        // Uten loadmodules fungerer ikke oppdatering av grafikknavn i kartlagsliste - uvisst hvorfor
        // eslint-disable-next-line no-unused-vars
        function([Map]) {
          this.allLayersLoaded = false;

          this.layers = [];

          this.layers.push(this.$theMapObject.findLayerById(this.layer));
          let layer = this.$theMapObject.findLayerById(this.layer);

          if (layer && layer.hasOwnProperty("sublayers")) {
            this.sublayers = this.$theMapObject.findLayerById(
              this.layer
            ).sublayers.items;
          } else {
            this.sublayers = [];

            this.graphics = layer.graphics.items;
          }
          this.allLayersLoaded = true;
        }.bind(this)
      );
    }
  },
  watch: {
    layer: function() {
      this.loadLayer();
    }
  },
  created() {},
  mounted() {
    this.loadLayer();
    this.$eventHub.$on("graphicslayer-updated", this.updateLayer);
  },
  beforeDestroy() {
    this.$eventHub.$off("graphicslayer-updated");
  }
};
</script>

<style scoped></style>
